module.exports = __webpack_public_path__ + "img/feature-clients.efed9b19.png";